module.exports={GLOBAL_CONFIG:"Main settings",SUBMIT_TRANSACTION_AFTER_AUTO_APPROVAL:"Submit transactions after auto approval"};